<template>
  <div class="container pt-5 pb-4 text-center">
    <img
      :src="config['studio-expired-img']"
      alt=""
      class="expired-studio-img p-1"
    />
    <div class="expired-studio-content mx-auto">
      <h1 class="my-4">
        {{ $t('STUDIO.TEXT.STUDIO_EXPIRED_TITLE') }}
      </h1>
      <div v-if="!isTeacher">
        <div class="c-charcoal">
          {{ $t('STUDIO.TEXT.STUDIO_EXPIRED_DESCRIPTION') }}
        </div>
        <a
          v-if="studio.studio_email"
          :href="`mailto:${studio.studio_email}`"
          target="_blank"
          class="btn btn-secondary mt-3"
        >
          {{ $t('STUDIO.TEXT.STUDIO_EXPIRED_CTA') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { getConfig } from '@/web/utils/configuration';

export default Vue.extend({
  name: 'ExpiredStudio',
  props: {
    isTeacher: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
    }),
    config() {
      return getConfig();
    },
  },
});
</script>

<style lang="scss" scoped>
.expired-studio-img {
  width: 369px;
  max-width: 100%;
}
.expired-studio-content {
  max-width: 470px;
}
</style>
